import { Pipe, PipeTransform } from '@angular/core';
import { ReferenceData } from '../models/reference-data.model';

@Pipe({ name: 'localizeAttribute' })
export class LocalizeAttributePipe implements PipeTransform {
  transform(referenceData: ReferenceData, attributeName: string): string {
    return referenceData.getAttributeValue(attributeName);
  }
}
